import React, { useState } from 'react'
import '../../index.css'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import VehicleSelect from '../UI/VehicleSelect'
import { styled } from '@mui/material/styles'
import { useSelector } from 'react-redux'

const PREFIX = 'Attack-dialog'
const classes = {
  main: `${PREFIX}`,
}

const DialogStyled = styled(Dialog)({
  [`&.${classes.main} .MuiDialogContent-root`]: {
    padding: '8px 24px',
  },
  [`&.${classes.main} .MuiTypography-h6`]: {
    textAlign: 'center',
  },
  [`&.${classes.main} .MuiOutlinedInput-input`]: {
    padding: '10.5px 14px',
  },
  [`&.${classes.main} .MuiFormLabel-root`]: {
    color: 'color: gray !important;',
    fontSize: 14,
  },
})

export default function AttackDialog(props) {
  const { projects, selectedProjectId } = useSelector(state => state)
  const [name, setName] = useState('')
  const [speed, setSpeed] = useState('')
  const [length, setLength] = useState('')
  const [vehicle, setVehicle] = useState('')
  const [errors, setErrors] = useState({})

  const units = projects.filter(p => p.id === selectedProjectId)[0].units

  const handleClose = () => {
    props.onChange(false)
    setName('')
    setSpeed('')
    setLength('')
    setVehicle('')
    setErrors({})
  }

  const validate = () => {
    const nextErrors = {}
    if (!name.trim()) nextErrors.name = 'Name is required'
    if (speed === '' || Number.isNaN(Number(speed)) || Number(speed) < 0) {
      nextErrors.speed = 'Starting speed must be 0 or greater'
    }
    if (!length || Number.isNaN(Number(length)) || Number(length) <= 0) {
      nextErrors.length = 'Path length must be a positive number'
    }
    if (!vehicle) nextErrors.vehicle = 'Vehicle type is required'
    setErrors(nextErrors)
    return Object.keys(nextErrors).length === 0
  }

  const handleOk = e => {
    if (e) e.preventDefault()
    if (!validate()) return

    props.onChange(
      false,
      name.trim(),
      String(Number(speed)),
      String(Number(length)),
      vehicle
    )
    setName('')
    setSpeed('')
    setLength('')
    setVehicle('')
    setErrors({})
  }

  const handleNameChange = e => {
    setName(e.target.value)
    if (errors.name) setErrors(prev => ({ ...prev, name: undefined }))
  }

  const handleLengthChange = e => {
    setLength(e.target.value)
    if (errors.length) setErrors(prev => ({ ...prev, length: undefined }))
  }

  const handleVehicleChange = (e, values) => {
    setVehicle(values?.vehicle || '')
    if (errors.vehicle) setErrors(prev => ({ ...prev, vehicle: undefined }))
  }

  const handleSpeedInputChange = e => {
    setSpeed(e.target.value)
    if (errors.speed) setErrors(prev => ({ ...prev, speed: undefined }))
  }

  return (
    <DialogStyled
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-attack"
      className={classes.main}
    >
      <DialogTitle id="form-dialog-title">Add Attack</DialogTitle>
      <DialogContent>
        <form onSubmit={handleOk}>
          <TextField
            autoFocus
            className="text-field-font"
            margin="dense"
            id="name"
            label="Name"
            variant="outlined"
            value={name}
            fullWidth
            required
            error={Boolean(errors.name)}
            helperText={errors.name}
            onChange={handleNameChange}
          />
          <TextField
            margin="dense"
            id="speed"
            label={`Starting Speed [${units.speedUnits}]`}
            variant="outlined"
            value={speed}
            type="number"
            inputProps={{ min: 0, step: 'any' }}
            fullWidth
            required
            error={Boolean(errors.speed)}
            helperText={errors.speed}
            onChange={handleSpeedInputChange}
          />
          <TextField
            margin="dense"
            id="length"
            label={`Path Length [${units.distanceUnits}]`}
            variant="outlined"
            value={length}
            type="number"
            inputProps={{ min: 0, step: 'any' }}
            fullWidth
            required
            error={Boolean(errors.length)}
            helperText={errors.length}
            onChange={handleLengthChange}
          />
          <VehicleSelect
            onChange={handleVehicleChange}
            value={vehicle}
            error={errors.vehicle}
          />
          <button
            type="submit"
            style={{ display: 'none' }}
            aria-hidden="true"
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} color="primary" type="submit">
          Add
        </Button>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </DialogStyled>
  )
}
